import { MessageCircle, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { scrollToId } from "../lib/site";

const NAV = [
  { id: "beranda", label: "Beranda", top: true },
  { id: "tentang", label: "Tentang Kami" },
  { id: "layanan", label: "Layanan" },
  { id: "produk", label: "Produk" },
  { id: "portofolio", label: "Portofolio" },
  { id: "kontak", label: "Kontak" },
];

const SERVICES = ["Cold Storage", "Freezer Room", "Chiller Room", "Blast Freezer", "Refrigeration", "Maintenance"];

export function Footer() {
  const { content, wa } = useSite();
  const s = content?.settings || {};
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer-section" className="bg-navy-950 border-t border-glacier/15">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-5">
            <span className="bg-white rounded-sm px-2 py-1.5 flex items-center">
              <img src="/logo-mark.png" alt="Logo SolusiCold" className="h-7 w-auto" loading="lazy" />
            </span>
            <span className="font-display text-xl font-bold tracking-wide uppercase"><span className="text-frost">Solusi</span><span className="text-ice">Cold</span></span>
          </div>
          <p className="text-sm text-steel leading-relaxed">{s.description || "Solusi cold storage berkualitas dengan harga terjangkau untuk berbagai industri di Indonesia."}</p>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.25em] text-ice uppercase mb-5">Navigasi</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button
                  data-testid={`footer-nav-${n.id}`}
                  onClick={() => (n.top ? window.scrollTo({ top: 0, behavior: "smooth" }) : scrollToId(n.id))}
                  className="text-sm text-steel hover:text-ice transition-colors"
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.25em] text-ice uppercase mb-5">Layanan</h4>
          <ul className="space-y-3">
            {SERVICES.map((sv) => (
              <li key={sv}>
                <button data-testid={`footer-service-${sv.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => scrollToId("layanan")} className="text-sm text-steel hover:text-ice transition-colors">
                  {sv}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.25em] text-ice uppercase mb-5">Kontak</h4>
          <ul className="space-y-3 text-sm text-steel">
            <li>
              <a data-testid="footer-wa" href={wa()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 hover:text-ice transition-colors">
                <MessageCircle className="w-4 h-4 text-glacier" /> {s.wa_display || "[Nomor WhatsApp]"}
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="w-4 h-4 text-glacier" /> {s.email || "[Email]"}
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin className="w-4 h-4 text-glacier mt-0.5 shrink-0" /> <span>{s.address || "[Alamat]"}</span>
            </li>
          </ul>
          <div className="flex gap-3 mt-6">
            {[
              { icon: Instagram, url: s.instagram, label: "Instagram" },
              { icon: Facebook, url: s.facebook, label: "Facebook" },
              { icon: Linkedin, url: s.linkedin, label: "LinkedIn" },
            ].map((sm) => (
              <a
                key={sm.label}
                data-testid={`footer-social-${sm.label.toLowerCase()}`}
                href={sm.url || "#"}
                target={sm.url ? "_blank" : undefined}
                rel="noopener noreferrer"
                aria-label={sm.label}
                className={`w-9 h-9 rounded-sm border flex items-center justify-center transition-colors ${sm.url ? "border-glacier/30 text-steel hover:text-ice hover:border-ice" : "border-glacier/10 text-steel/30 pointer-events-none"}`}
              >
                <sm.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-glacier/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-3">
          <p className="text-xs text-steel/70">© {year} {s.company_name || "[Nama Perusahaan]"}. All Rights Reserved.</p>
          <p className="font-mono text-[10px] tracking-[0.25em] text-steel/50 uppercase">Berkualitas • Profesional • Harga Kompetitif</p>
        </div>
      </div>
    </footer>
  );
}
